
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Composant qui fait défiler la page vers le haut lors des changements de route
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force le scroll en haut immédiatement
    window.scrollTo(0, 0);
    
    // Backup avec un petit délai pour s'assurer que le DOM est rendu
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);

    return () => clearTimeout(timer);
  }, [pathname]);

  // Scroll également en haut au montage du composant
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null; // Ce composant ne rend rien visuellement
};

export default ScrollToTop;
